module.exports = __webpack_public_path__ + "static/media/NimbusSanL-Bol.f056144b.woff";